import React, { useEffect } from "react";

import ReactGA from "react-ga";
import { useLocation } from "react-router-dom";
import { useApp } from "@/containers/Apps/AppContext";
import { useAuth } from "@/containers/Auth/AuthContext";

const GoogleAnalytics = () => {
  const location = useLocation();
  const { config } = useApp();
  const { user } = useAuth();

  useEffect(() => {
    if (config.googleAnalyticsTracker) {
      ReactGA.initialize(config.googleAnalyticsTracker, {
        gaOptions: {
          userId: user.id,
        },
      });
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [user.id, config.googleAnalyticsTracker, location]);

  return <></>;
};

export default GoogleAnalytics;
